import React from "react"
import { SEOHead } from "components/SEO"
import EaseOfUseSection from "components/pages/use-cases/internal-tooling/EaseOfUseSection"
import HeroSection from "components/pages/use-cases/internal-tooling/HeroSection"
import InteractiveAnalyticsAnywhereSection from "components/pages/use-cases/internal-tooling/InteractiveAnalyticsAnywhereSection"
import SelfServeVisualizationSection from "components/pages/use-cases/internal-tooling/SelfServeVisualizationSection"
import UserManagementAndAccessControlSection from "components/pages/use-cases/internal-tooling/UserManagementAndAccessControlSection"
import DividerSection from "components/ui/Blocks/DividerSection"
import DoubleCTASection from "components/ui/Blocks/DoubleCTASection"
import Layout from "components/ui/Layout"

function InternalTooling({ location: { pathname } }) {
  return (
    <Layout
      contentSpaced
      trackingName="Use Cases - Internal Tooling"
      pageName="internal-tooling"
      pagePath={pathname}
    >
      <HeroSection />
      <div>
        <InteractiveAnalyticsAnywhereSection className="lg:-mt-10 2xl:mt-0" />
        <SelfServeVisualizationSection />
        <EaseOfUseSection className="-my-20 2xl:-my-24" />
        <UserManagementAndAccessControlSection />
      </div>
      <DividerSection />
      <DoubleCTASection
        noHeading
        noBackground
        trackingName="Use Cases - Internal Tooling"
      />
    </Layout>
  )
}

// Export a Head component for Gatsby Head API
export function Head() {
  return (
    <SEOHead
      title="Embed Analytics in Internal Tools for Your Organization"
      description="Add Preset's charts and dashboards in your internal tools to save time, money, and effort integrating analytics into existing workflows."
    />
  )
}

export default InternalTooling
